import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Render the button as a child element (e.g., an <a> tag) by cloning it
   */
  asChild?: boolean;
  /**
   * Additional CSS classes to apply
   */
  className?: string;
}

/**
 * Botón estilizado con Tailwind CSS que puede renderizarse como <button>
 * o, si se pasa `asChild`, clona su elemento hijo (útil para <a>, <Link>, etc.)
 *
 * Variante: borde blanco, fondo transparente y texto blanco
 */
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ asChild = false, children, className = '', ...props }, ref) => {
    const baseClasses =
      'border border-white bg-transparent text-white font-semibold transition-colors hover:bg-white hover:text-black';

    if (asChild && React.isValidElement(children)) {
      const child = children as React.ReactElement<any, any>;
      const combinedClass = `${baseClasses} ${className} ${child.props.className || ''}`.trim();
      return React.cloneElement(child, {
        ...props,
        className: combinedClass,
        ref,
      });
    }

    return (
      <button ref={ref} className={`${baseClasses} ${className}`} {...props}>
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
